import { Button, Content, Headline, TextButton } from "@volumental/common";
import type { JSX } from "react";

interface MidJourneyIntroProps {
  title: string;
  subTitle?: string;
  imageSrc: string;
  altText: string;
  buttonText: string;
  onClick?: () => void;
  skipButtonText: string;
  onSkip?: () => void;
}

export function MidJourneyIntro({
  title,
  subTitle,
  imageSrc,
  altText,
  buttonText,
  skipButtonText,
  onSkip,
  onClick,
}: MidJourneyIntroProps): JSX.Element {
  return (
    <>
      <Content disableScrollbar>
        {onSkip && subTitle && (
          <div className="shrink-0 basis-auto font-normal text-base text-black pb-2.5 text-left pt-6">{subTitle}</div>
        )}
        <Headline className="shrink-0 basis-auto text-xl text-black font-normal mb-7 text-left">{title}</Headline>
        <div className="w-full flex flex-row min-h-32 max-h-90 justify-center">
          <img data-cy="intro-image" src={imageSrc} alt={altText} className="w-full h-full object-cover rounded-xl" />
        </div>
      </Content>
      <div className="p-6 content-center justify-items-center flex flex-col">
        <Button onClick={onClick}>{buttonText}</Button>
        {onSkip && <TextButton onClick={onSkip}>{skipButtonText}</TextButton>}
      </div>
    </>
  );
}
